/* eslint-disable no-nested-ternary */
import React, { useState, useContext } from 'react';
import { Button } from '@material-ui/core';
import { Resolve, Delete } from '@mummssoftware/utils/constants';
import { CPPContext } from '../Context/CPPContext';
import { cppResolveYes, cppResolve } from '../Context/constants';
import { EffDate } from './components/EffDate';
import {
  ButtonDiv,
  ConfirmModalDiv,
  ModalText,
  SpanDiv,
} from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

type ConfirmModalProps = {
  onOKClick: () => void;
  onCancelClick: () => void;
  patientCPP?: any;
  type: typeof Resolve | typeof Delete;
};

const ConfirmModal = ({
  onOKClick,
  onCancelClick,
  patientCPP,
  type,
}: ConfirmModalProps) => {
  const { resolveDate } = useContext(CPPContext);
  const [showFirstModal, setFirstModal] = useState<boolean>(true);
  const modalFirstText =
    type === Resolve ? defaults.resolveConfirm : defaults.deleteConfirm;

  const getUI = () =>
    showFirstModal ? (
      <ModalText>{modalFirstText}</ModalText>
    ) : (
      <>
        <EffDate patientCPP={patientCPP} />
      </>
    );
  const onOKResolve = () => setFirstModal(false);
  const onClick = showFirstModal && type === Resolve ? onOKResolve : onOKClick;
  const okText = showFirstModal ? defaults.yes : defaults.ok;
  const noText = showFirstModal ? defaults.no : defaults.cancel;
  const okButtonDisabled = showFirstModal ? false : !resolveDate;
  const id = showFirstModal ? cppResolve : cppResolveYes;

  return (
    <ConfirmModalDiv>
      {getUI()}
      <ButtonDiv>
        <Button
          id={id}
          title="OK"
          size="small"
          variant="contained"
          color="primary"
          disabled={okButtonDisabled}
          onClick={onClick}
        >
          <SpanDiv id={id}>{okText}</SpanDiv>
        </Button>
        <Button
          title="Cancel"
          size="small"
          variant="contained"
          color="primary"
          onClick={onCancelClick}
        >
          {noText}
        </Button>
      </ButtonDiv>
    </ConfirmModalDiv>
  );
};
export default ConfirmModal;
